import React from 'react'
import { BText, BRow, BTitle, BCol, BLink } from '@prague-digi/ui-components'

import messages from '../../i18n'
import money from '../../assets/money-hand.svg'
import styles from './styles.scss'
import { intl, IntlInterface } from '../../hoc'
import { URL } from '../../constants'
import { InfoCheckbox } from '../../components'

interface Props extends IntlInterface {
  amount: number
}

export const InsuranceQuestion: React.FC<Props> = (props: Props) => (
  <>
    <BRow>
      <BCol theme="text-center">
        <img src={money} alt="moneyIcon" className={styles.headerIcon} />
      </BCol>
    </BRow>
    <BTitle type="h3" center>
      {props.translate(messages.InsuranceQuestion.title)}
    </BTitle>
    <BText center type="primary">
      {props.translate(messages.InsuranceQuestion.subTitle, {
        amount: props.amount,
      })}
    </BText>

    <InfoCheckbox className="pl-0 pl-md-5">
      {props.translate(messages.InsuranceQuestion.bullet1)}
    </InfoCheckbox>
    <InfoCheckbox className="pl-0 pl-md-5">
      {props.translate(messages.InsuranceQuestion.bullet2)}
    </InfoCheckbox>
    <InfoCheckbox className="pl-0 pl-md-5">
      {props.translate(messages.InsuranceQuestion.bullet3)}
    </InfoCheckbox>
    <InfoCheckbox className="pl-0 pl-md-5">
      {props.translate(messages.InsuranceQuestion.bullet4)}
    </InfoCheckbox>

    <BRow theme="mt-2">
      <BCol theme="text-center">
        <BLink
          href={URL.MONETA_INSURANCE_INFO}
          target="_blank"
          theme={styles.underline}
          type="link">
          {props.translate(messages.InsuranceQuestion.moreInfo)}
        </BLink>
      </BCol>
    </BRow>
  </>
)

export default intl(InsuranceQuestion)
